import toArray from '../../../arn/frontend/scripts/utils/to-array';

const YtVideos = () => {
  const sections = toArray(document.querySelectorAll('.yt-videos'));
  if(!sections) {
    return;
  }
  sections.forEach(section => {
    import('./Videos' /* webpackChunkName: "videos" */).then(
      ({ initializeForElement }) => {
        initializeForElement(section);
      }
    );
  });
};

YtVideos();

window.youtubeVideos = YtVideos;
